import type { RouteRecordRaw } from 'vue-router';
import onboardingRoutes from './onboarding/onboardingRoutes';
import transactionRoutes from './transaction/transactionRoutes';
import { multiTransactionRoutes } from '@/modules/multiTransactionV2/router/multiTransaction.private.route';
import { multiTransactionMovementsRoutes } from '@/modules/multiTransactionV2/router/multiTransactionMovements.private.route';
import cashInRoutes from './cashIn/cashInRoutes';
import exchangeRoutes from './exchange/exchangeRoutes';
import { profileRoutes } from '@/modules/profile/router/profile.private.route';
import movementsRoutes from './movements/movementsRoutes';
import SuccessTransactionView from '@/views/SuccessTransactionView.vue';
import localTransaction from './localTransaction/localTransaction';
import { otpRoutes } from '@/shared/otp';
import { notificationRoutes } from '@/modules/notification';
import { cardRoutes } from '@/modules/card/router/card.private.route';
import { dashboardRoutes } from '@/modules/dashboard/router/dashboard.private.route';
import { commerceRoutes } from '@/modules/commerce/router/commerce.private.route';
import { walletRoutes } from '@/modules/wallet/router/wallet.private.route';
import { additionalWalletDetailRoutes } from '@/modules/wallet/router/additionalWalletDetail.private.route';
import { comexRoutes } from '@/modules/comex/router/comex.private.route';
import teamRoutes from './team/team.private.routes';
import { transactionApprovalRoutes } from '@/modules/transactionApproval/router/transactionApproval.private.route';
import { contactsPrivateRoutes } from '@/modules/contacts/router/contacts.private.route';
import { webhooksRoutes } from '@/modules/webhooks/router/webhooks.private.route';
import { referralRoutes } from '@/modules/referral';
import { paymentLinksRoutes } from '@/modules/paymentLinks';
import { rfqRoutes } from '@/modules/rfq/router/rfq.private.route';
import { credentialApiRoutes } from '@/modules/credentialApi/router/credentialApi.private.route';
import { expenseManagementRoutes } from '@/modules/expenseManagement/router/expenseManagement.private.route';
import { scheduledTransferRoutes } from '@/modules/scheduledTransfer/router/scheduledTransfer.private.route';
import { additionalAccountsRoutes } from '@/modules/additionalAccounts/router/additionalAccounts.private.route';
import { jumioRegularizationRoutes } from '@/shared/jumioRegularization/router/jumioRegularization.private.route';

const privateRoutes: Array<RouteRecordRaw> = [
  ...rfqRoutes,
  ...dashboardRoutes,
  ...walletRoutes,
  ...additionalWalletDetailRoutes,
  ...movementsRoutes,
  ...onboardingRoutes,
  ...multiTransactionRoutes,
  ...multiTransactionMovementsRoutes, // ← Rutas de visualización de multienvíos
  ...transactionRoutes,
  ...cashInRoutes,
  ...exchangeRoutes,
  ...profileRoutes,
  ...localTransaction,
  ...otpRoutes,
  ...notificationRoutes,
  ...cardRoutes,
  ...commerceRoutes,
  ...comexRoutes,
  ...teamRoutes,
  ...transactionApprovalRoutes,
  ...contactsPrivateRoutes,
  ...webhooksRoutes,
  ...referralRoutes,
  ...paymentLinksRoutes,
  ...credentialApiRoutes,
  ...expenseManagementRoutes,
  ...scheduledTransferRoutes,
  ...additionalAccountsRoutes,
  ...jumioRegularizationRoutes,
  {
    path: '/successful-transaction',
    name: 'successfulTransaction',
    component: SuccessTransactionView,
    meta: { isPaymentCallback: true },
  },
];

privateRoutes.forEach((route) => {
  if (!route.meta) {
    route.meta = {};
  }
  route.meta['requiresAuth'] = true;
  route.meta['title'] = String(route.name);
});

export default privateRoutes;
